/**************************************************
 * Nombre:       Boton
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Box, Button, IconButton, Typography} from "@mui/material";
import {ArrowForward} from "@mui/icons-material";
import {theme} from "../../../../Tema";
import {COLORTEXTO} from "../../../../Constantes";


const Boton = ({color = 'primary', texto = 'Ingresar', click, habilitado = false}) => {

    return (
        <Box>


            <Button
                disabled={!habilitado}
                color={color}
                onClick={(e) => click()}
                //sx={{color: theme.palette.primary.main}}
            >
                {texto}
            </Button>

            <IconButton
                disabled={!habilitado}
                onClick={(e) => click()}
                sx={{backgroundColor: color === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main}}>

                {habilitado ?
                    <ArrowForward sx={{fill: color === 'primary' ? '#fff' : COLORTEXTO, p: 1, width: 20, height: 20}}/>
                    :
                    <ArrowForward sx={{fill: COLORTEXTO, p: 1, width: 20, height: 20}}/>

                }

            </IconButton>
        </Box>
    )

}
export default Boton